// extracted by mini-css-extract-plugin
module.exports = {"trending":"_2duXQ"};